import gsap from "gsap";

const DESKTOP_MQ = "(min-width: 1024px)";
const METER_STEP = 16;
const LIGHT_BG_SELECTOR =
  ".has-light-blue-background-color:not(.info-card), .has-beige-background-color:not(.info-card)";

let funiculaireMatchMedia;

const setActiveDot = (track, dots, meter, index) => {
  track.style.setProperty("--active-index", index);
  dots.forEach((dot, dotIndex) => {
    dot.classList.toggle("is-active", dotIndex === index);
  });
  if (meter) {
    meter.textContent = `${index * METER_STEP}m`;
  }
};

export const initFuniculaireScroll = () => {
  const nav = document.querySelector("[data-funiculaire-nav]");
  const track = document.querySelector("[data-funiculaire-track]");
  const meter = document.querySelector("[data-funiculaire-meter]");

  if (!nav || !track) return;

  const dots = Array.from(track.querySelectorAll("[data-funiculaire-dot]"));

  if (!dots.length) return;

  funiculaireMatchMedia?.revert();
  funiculaireMatchMedia = gsap.matchMedia();

  funiculaireMatchMedia.add(DESKTOP_MQ, () => {
    const targets = dots.map((dot) => {
      const hash = dot.getAttribute("href")?.split("#")[1];
      return hash ? document.getElementById(hash) : null;
    });

    // Recomputed from scratch on every scroll instead of tracked via
    // per-section enter/leave events: clicking a dot can jump straight past
    // several other sections' trigger points in one tick, and whichever of
    // those fired last would otherwise win — leaving the wrong dot active.
    const updateActiveDot = () => {
      const viewportCenter = window.innerHeight / 2;
      let activeIndex = 0;

      targets.forEach((target, index) => {
        if (target && target.getBoundingClientRect().top <= viewportCenter) {
          activeIndex = index;
        }
      });

      setActiveDot(track, dots, meter, activeIndex);
    };

    updateActiveDot();
    window.addEventListener("scroll", updateActiveDot, { passive: true });
    window.addEventListener("resize", updateActiveDot);

    const lightSections = Array.from(
      document.querySelectorAll(LIGHT_BG_SELECTOR),
    );
    const activeLightSections = new Set();
    let lightBgObserver;

    if (lightSections.length) {
      lightBgObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              activeLightSections.add(entry.target);
            } else {
              activeLightSections.delete(entry.target);
            }
          });
          nav.classList.toggle(
            "funiculaire-nav--on-light",
            activeLightSections.size > 0,
          );
        },
        { rootMargin: "-50% 0px -50% 0px", threshold: 0 },
      );

      lightSections.forEach((section) => lightBgObserver.observe(section));
    }

    return () => {
      window.removeEventListener("scroll", updateActiveDot);
      window.removeEventListener("resize", updateActiveDot);
      lightBgObserver?.disconnect();
    };
  });
};
